export default {
  getDateDiff(diff) {
    //计算出相差年数
    let years = Math.floor(diff / (365 * 24 * 3600 * 1000))
    //计算出相差月数
    let months = Math.floor(diff / (30 * 24 * 3600 * 1000))
    //计算出相差天数
    let days = Math.floor(diff / (24 * 3600 * 1000))
    //计算出小时数
    let leave1 = diff % (24 * 3600 * 1000)
    let hours = Math.floor(leave1 / (3600 * 1000))
    //计算相差分钟数
    let leave2 = leave1 % (3600 * 1000)
    let minutes = Math.floor(leave2 / (60 * 1000))
    //计算相差秒数
    // let leave3 = leave2 % (60 * 1000)
    // let seconds = Math.round(leave3 / 1000)

    if (years > 0) {
      return {key: 'years', years}
    } else if (months > 0) {
      return {key: 'months', months}
    } else if (days > 0) {
      return {key: 'days', days}
    } else if (hours > 0) {
      return {key: 'hours', hours}
    } else if (minutes > 0) {
      return {key: 'minutes', minutes}
    } else {
      return {key: ''}
    }
  },
  timeDiffAll: (time) => {
    let diffTimes = new Date().getTime() - new Date(time).getTime()
    let hourStr = ' just now'
    let flagStyle = true
    let finTime = 0
    let diffTimeM = diffTimes / (60 * 1000)
    let diffTimeH = diffTimes / (3600 * 1000)
    let diffTimeD = diffTimes / (3600 * 1000 * 24)

    if (diffTimeD >= 365) {
      flagStyle = false
      finTime = diffTimeD / 365
      hourStr = finTime > 1 ? ' years ago' : ' year ago'
    } else if (diffTimeD > 30) {
      flagStyle = false
      finTime = diffTimeD / 30
      hourStr = finTime > 1 ? ' months ago' : ' month ago'
    } else if (diffTimeH >= 24) {
      flagStyle = false
      finTime = diffTimeD
      hourStr = finTime > 1 ? ' days ago' : ' day ago'
    } else if (diffTimeM >= 60) {
      finTime = diffTimeH
      hourStr = finTime > 1 ? ' hrs ago' : ' hr ago'
    } else if (diffTimeM >= 1) {
      finTime = diffTimeM
      hourStr = finTime > 1 ? ' mins ago' : ' min ago'
    }
    let timeDiffData = ''
    if (Math.floor(finTime) > 0) {
      if (Math.floor(finTime) > 1) {
        timeDiffData = Math.floor(finTime) + hourStr
      } else {
        timeDiffData = Math.floor(finTime) + hourStr.replace(/s\s/, ' ')
      }
    } else {
      timeDiffData = hourStr
    }
    return {
      timeDiffData,
      flagStyle: flagStyle
    }
  }

}
